<template>
  <div class="invite-bottom-bar">
    <div class="invite-bottom-bar__buttons">
      <div class="invite-bottom-bar__btn invite-bottom-bar__btn--kakao" @click="$emit('kakao-click')">
        <span class="typo-btn-m-medium" style="color: var(--color-text-accent, #008DEF);">카카오톡 공유</span>
      </div>
      <div class="invite-bottom-bar__btn invite-bottom-bar__btn--link" @click="$emit('link-click')">
        <span class="typo-btn-m-medium" style="color: var(--color-white, #FFF);">초대 링크 복사</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InviteBottomBar',
}
</script>

<style scoped>
.invite-bottom-bar {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  width: 100%;
  max-width: 600px;
  height: 102px;
  padding: 16px 20px 32px 20px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  box-sizing: border-box;
  background: linear-gradient(0deg, #FFF 0%, rgba(255, 255, 255, 0.00) 255.33%);
  z-index: 10;
}

.invite-bottom-bar__buttons {
  display: flex;
  width: 100%;
  gap: 8px;
}

.invite-bottom-bar__btn {
  display: flex;
  flex: 1;
  height: 54px;
  padding: 16px 0;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;
}

.invite-bottom-bar__btn--kakao {
  background: var(--gray-20, #F3F5F8);
}

.invite-bottom-bar__btn--link {
  background: var(--primary-100, #008DEF);
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/InviteBottomBar.vue